import React from "react";
import { useLang } from "@/context/LanguageContext";
import { SLOTS } from "@/i18n/content";
import { Reveal } from "@/components/site/Reveal";

export default function Schedule() {
  const { t } = useLang();

  return (
    <section id="schedule" data-testid="schedule-section" className="bg-navy text-white py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal className="max-w-3xl mb-14">
          <p className="label-mono text-sand mb-6">{t.schedule.label}</p>
          <h2 className="font-outfit font-semibold text-4xl md:text-6xl tracking-tight whitespace-pre-line">
            {t.schedule.title}
          </h2>
          <p className="font-manrope text-white/60 text-base md:text-lg mt-5">{t.schedule.sub}</p>
        </Reveal>

        <Reveal>
          <div className="border border-white/15">
            {SLOTS.map((slot, i) => (
              <div
                key={slot.id}
                data-testid={`schedule-row-${slot.id}`}
                className={`grid grid-cols-1 md:grid-cols-12 items-center gap-4 px-6 md:px-10 py-7 ${
                  i !== SLOTS.length - 1 ? "border-b border-white/15" : ""
                } hover:bg-white/5 transition-colors`}
              >
                <div className="md:col-span-4">
                  <h3 className="font-playfair italic text-2xl md:text-3xl text-sand">
                    {t.schedule.slotNames[slot.id]}
                  </h3>
                </div>
                <div className="md:col-span-4">
                  <span className="font-mono text-lg md:text-xl tracking-wide">{slot.time}</span>
                </div>
                <div className="md:col-span-4 flex md:justify-end flex-wrap gap-2">
                  {t.schedule.days.map((d) => (
                    <span
                      key={d}
                      className="label-mono border border-white/20 px-2.5 py-1 text-white/70"
                    >
                      {d}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
